// extracted by mini-css-extract-plugin
module.exports = {"container":"DownloadAndroid_container__3e5fR","btn-download":"DownloadAndroid_btn-download__1-pxk"};